<div *ngIf="listItem" class="file-row noselect"
     [class.center75]="true">
  <div>
    <img alt="" title="{{listItem.name}}"
         src="{{listItem.picture_ava}}" class="list-item-image"
         style="{{ listItem.itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
    />
  </div>

  <div class="file-name noselect">
    {{listItem.name}}<br/>
    <div class="subrow subrow-trainer flex-row-center" *ngIf="listItem.isTrainer">
      <mat-icon style="width: 16px;">phone</mat-icon>&nbsp;&nbsp;&nbsp;+{{listItem['itemFullData']['shipping_phone']}}
    </div>
  </div>
  <div class="file-menu">
    <button mat-icon-button (click)="clickOnItemMenu($event)"
            [matMenuTriggerFor]="trainerMenu">
      <mat-icon>more_horiz</mat-icon>
    </button>
  </div>
</div>

<mat-menu #trainerMenu="matMenu" class="file-menu">
  <button mat-menu-item (click)="click.emit()">
    <mat-icon>info</mat-icon>{{'more'|GetLabelPipe}}
  </button>
  <button mat-menu-item (click)="showTrainerPhone()">
    <mat-icon>phone</mat-icon>{{'trainer_phone'|GetLabelPipe}}
  </button>
</mat-menu>
